import { useBunja } from 'bunja/react';
import { useAtom } from 'jotai';

import { Link } from '@flipster/i18n/routing';
import { Checkbox } from '@flipster/react/design-system/checkbox';
import { css } from '@flipster/styled-system/css';

import { copyTradingSettingsBunja } from '../../state';

interface AgreeTncSectionProps {
  onClose: () => void;
}

export const AgreeTncSection = ({ onClose }: AgreeTncSectionProps) => {
  const { agreedTncAtom } = useBunja(copyTradingSettingsBunja);
  const [agreedTnc, setAgreedTnc] = useAtom(agreedTncAtom);
  return (
    <Checkbox
      css={{ textStyle: 'Text/M/Regular' }}
      checked={agreedTnc}
      onChange={(e) => setAgreedTnc(e.target.checked)}
    >
      I have read and agree to the{' '}
      <Link
        className={css({ textStyle: 'Text/M/Underline', color: 'content.accent.info' })}
        href='/policies/terms'
        onClick={onClose}
      >
        Terms of Use
      </Link>{' '}
      and the{' '}
      <Link
        className={css({ textStyle: 'Text/M/Underline', color: 'content.accent.info' })}
        href='/policies/copy-trading-specific-terms'
        onClick={onClose}
      >
        Copy Trading Policy
      </Link>
    </Checkbox>
  );
};
